import React, { useState } from "react";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import styles from "./VerifyPhoneNumberVerifyMethodModal.module.scss";
import { VerifyMethod, RadioOption } from "../VerifyMethod";
import { useTranslation } from "react-i18next";

export const VerifyPhoneNumberVerifyMethodModal: React.FC<IModalInstance<RadioOption>> = ({ closeModal }) => {
  const { t } = useTranslation();
  const [verifyMethod, setVerifyMethod] = useState<RadioOption | undefined>();

  return (
    <BaseModal
      header={<ModalHeader closeModal={() => closeModal()}>{t("whatsapp_business_api_settings_page.verifyMethodModal.title")}</ModalHeader>}
      footer={
        <ModalButtons
          isSubmitDisabled={!verifyMethod}
          testId="modal-buttons-submit-button"
          onCancel={() => closeModal()}
          onSubmit={() => closeModal(verifyMethod)}
          submitText={t("whatsapp_business_api_settings_page.verifyMethodModal.submit_button")}
        />
      }
      closeOnClickOutside={false}
      closeOnEscape={false}
      closeModal={() => closeModal()}
      className={styles.modal}
    >
      <div data-testid="verify-phone-method-modal">
        <div className={styles.text}>{t("whatsapp_business_api_settings_page.verifyMethodModal.text")}</div>
        <div className={styles.desc}>{t("whatsapp_business_api_settings_page.verifyMethodModal.desc")}</div>
        <VerifyMethod setVerifyMethod={setVerifyMethod} />
      </div>
    </BaseModal>
  );
};
